import { putAxios, getAxios, postAxios } from "services/api/api.service";
import { PlanningObject } from "./PlannerFlow.model";
import { apiNames } from "services/api/endpoint.service";
import * as mocks from "./PlannerFlow.mock";
import { getLanguageTMB } from "../TmbDetailActivity/TmbDetailActivity.service";

export function mapPlanningObject(obj: PlanningObject): PlanningObject {
	delete obj.destination.value.productAtStop;
	delete obj.origin.value.productAtStop;
	// obj.return = obj.arrivalDate.invalid || !obj.arrivalDate.value ? false : true;
	return obj;
}

export function getUsersUnder16Literals(t: any) {
	return {
		title: t("getUsersUnder16Literals.title"),
		desc: t("getUsersUnder16Literals.desc"),
		confirmButton: t("getUsersUnder16Literals.confirmButton"),
	};
}
export function getErrorSelectTariffLiterals(t: any) {
	return {
		title: t("getErrorSelectTariffLiterals.title"),
		desc: t("getErrorSelectTariffLiterals.desc"),
		confirmButton: t("getErrorSelectTariffLiterals.confirmButton"),
	};
}





export function apiUpdateUnder16Age(
	under16: boolean,
	callback: Function,
	callbackError: Function,
) {
	putAxios(apiNames.PROFMANAG, true, "/customers/profiles", {
		under16: under16,
	})
		.then((response: any) => callback(response))
		.catch((err) => callbackError(err));
}

const mockTmbCard = {
	catalogues: [
		{
			id: "holabarcelona-travel-card",
			name: "Hola Barcelona Travel Card",
			description:
				"Disfruta de viajes ilimitados en el transporte público de Barcelona durante 2 días (48h), 3 días (72h), 4 días (96h) o 5 días (120h).",
			image: "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			price: {
				gross: 1476,
				taxes: 0.0,
				includedTaxes: 1476,
				currency: "EUR",
			},
		},
		{
			id: "bus-turístico-barcelona",
			name: "Bus Turístico Barcelona",
			description:
				"Descubre los lugares más emblemáticos de Barcelona recorriendo sus calles con el autobús turístico oficial.",
			image: "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			price: {
				gross: 2142, //21,42€
				taxes: 0.0,
				includedTaxes: 2142,
				currency: "EUR",
			},
		},
		{
			id: "teleférico-de-montjuïc",
			name: "Teleférico de Montjuïc",
			description:
				"Sube al Teleférico de Montjuïc y contempla la panorámica de Barcelona desde un lugar privilegiado.",
			image: "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			price: {
				gross: 1350,
				taxes: 0.0,
				includedTaxes: 1350,
				currency: "EUR",
			},
		},
	],
};
export function getDataTmbActivities(
	logged: boolean,
	callback: Function,
	callbackError: Function,
	lenguage: any,
	mock?: any,
) {
	if (mock === "true") {
		const mockData = mocks.getTmbCards.data;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
		callback(mockData);
	} else {
		// v1
		// const apiWithParams = `/catalogues?language=${lenguage}`;
		// v2
		const apiWithParams = `/catalogues/v3?language=${lenguage}`;
		getAxios(apiNames.TRVLMANAG, false, apiWithParams,true)
			.then((data: any) => {
				let result={
					catalogues:data.data.catalogues,
					privacyPolicy:data.data.privacyPolicy,
					termsAndConditions:data.data.termsAndConditions
				}
				callback(result);
			})
			.catch((error: any) => {
				callbackError(error);
			});
	}
}



export function getNotificationsCall(
	callback: Function,
	errorCallback: Function
  ) {
	const body={"device":"web","version":sessionStorage.getItem('raas-version')}
	postAxios(apiNames.SUPPORT, false, "/version", body)
	  .then((data: any) => {
		callback(data);
	  })
	  .catch((error: any) => {
		errorCallback(error);
	  });
  }